export const module = {
  info: {
    name: 'voip-testing-panel-side-menu',
    caption: 'voip testing panel side menu',
    viewGroup: 'testing-tools'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Testing Panel',
    icon: 'el-icon-phone-outline',
    routeName: 'module->voip-testing-panel->panel-tabs->tab',
    routeParams: { tabName: 'testingTool'}

    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-testing-panel-side-menu->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-testing-panel-side-menu->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
